import request from '@/utils/http';
const otpBaseUrl = 'api-antms/lsp';
// 车牌分页查询
export const vehicleCardGetList = (data) => {
    return request({
        url: `${otpBaseUrl}/vehicle/info/page`,
        method: 'POST',
        data
    });
};

// 新增车牌配置
export const addVehicleCard = (data) => {
    return request({
        url: `${otpBaseUrl}/vehicle/info/save`,
        method: 'POST',
        data
    });
};


// 删除车牌配置
export const deleteVehicleCard = (data) => {
    return request({
        url: `${otpBaseUrl}/vehicle/info/delete`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data
    });
};

